<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 126 58"
  [attr.height]="size"
  [attr.width]="size * 2.17"
>
  <g fill="rgb(36,17,75)">
    <path
      d="m108 35.3c-5-1.3-7-1.8-7-4.2s1.6-3 4.5-3 5.1 1.4 6.6 3.1l4.5-4.4c-2.4-2.6-6-4.8-11.1-4.8s-11.3 3-11.3 9.4 4.7 8.5 9.4 9.8c5.4 1.5 7.7 1.9 7.7 4.5s-1.7 3.4-5.6 3.4-6.2-1.1-8.2-3.6l-4.6 4.5c2.5 2.9 7 5.3 13.2 5.3 9 0 12.3-4.5 12.3-9.9s-5.5-8.7-10.4-10z"
    ></path>
    <path
      d="m47.9 48.8c4.2 0 7.2-1.7 9-3.4l4.5 4.7c-3 3-7 5.1-13.4 5.1-10.9 0-18-7-18-16.6s7.4-16.6 17-16.6 17 8 16.5 19.2h-25.6c.9 4.6 4.2 7.6 10.1 7.6zm7.8-12.9c-.7-4.3-3.3-7.5-8.6-7.5s-8.3 2.7-9.3 7.5z"
    ></path>
    <path d="m68.8 1.6h7.4v53h-7.4z"></path>
    <path d="m81.4 22.3h7.5v32.2h-7.5z"></path>
    <path
      d="m80.3 11.7c0-2.8 2.3-4.9 4.9-4.9s4.9 2.1 4.9 4.9-2.3 4.9-4.9 4.9-4.9-2-4.9-4.9z"
    ></path>
    <path d="m26.5 29.1 4.4-6.8h-27.4v6.8z"></path>
    <path d="m1 54.6h27.5v-6.8h-23z"></path>
    <path d="m6.9 45.6 8.9-.1 9.2-14.1h-8.8z"></path>
    <path
      d="m122.1 51.6c.3 0 .5.2.5.5s-.2.5-.5.5h-.8v-1zm.5 2.5h.5l-.7-1.1c.2 0 .7-.2.7-.8s-.4-.8-.9-.8h-1.2v2.8h.4v-1.1h.5l.7 1.1zm-.7-3.5c1.2 0 2.1.9 2.1 2.1s-.9 2.1-2.1 2.1-2.1-1-2.1-2.1.9-2.1 2.1-2.1m0 4.6c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5-2.5 1.1-2.5 2.5 1.1 2.5 2.5 2.5"
    ></path>
  </g>
</svg>
